import { CommonModule } from "@angular/common";
import {
  Component,
  inject,
  OnInit
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MessageService } from "primeng/api";
import { Observable } from "rxjs";
import { DataViewModalComponent } from "../../../components/modal-templates/data-view-modal/data-view-modal.component";
import { DeleteCautionModalComponent } from "../../../components/modal-templates/delete-caution-modal/delete-caution-modal.component";
import { DeleteConfirmationComponent } from "../../../components/modal-templates/delete-confirmation/delete-confirmation.component";
import { EditorItemModalComponent } from "../../../components/modal-templates/generic-modal/editor-item-modal.component";
import { ScriptDuplicateModalComponent } from "../../../components/modal-templates/script-duplicate-modal/script-duplicate-modal.component";
import { ScriptMappingComponent } from "../../../components/modal-templates/script-mapping/script-mapping.component";
import { SharedImports } from "../../../components/shared.module";
import { testPrioritizationModalConfig } from "../../../core/generic-templates/modal-config-templates";
import { AutomationActions } from "../../../core/ngrx/actions/automation.actions";
import {
  selectAutomationError,
  selectCombinedTestSuiteComponent,
  selectLoading,
  selectTestScript,
} from "../../../core/ngrx/selectors/automation.selectors";
import { testScriptDeleteTableColumns, testSuiteDeleteTableColumns } from "../../../core/table-templates/test-script-caution-table";
import { testSuiteTableColumns } from "../../../core/table-templates/test-suite-table";
import { MessageEnum } from "../../../core/utils/message.enum";
import { BaseLayoutComponent } from "../../base-layout.component";

@Component({
  selector: "app-standard-test-suite",
  standalone: true,
  imports: [CommonModule, ...SharedImports, DeleteConfirmationComponent],
  templateUrl: "./standard-test-suite.component.html",
  styleUrl: "./standard-test-suite.component.scss",
})
export class StandardTestSuiteComponent
  extends BaseLayoutComponent
  implements OnInit {
  columns: any = testSuiteTableColumns;
  folders: any = [];
  selectCombinedTestSuiteComponent$!: Observable<any>;
  scriptTestScript$!: Observable<any>;

  automationProjectID: any;
  projectID: any;
  loading$!: Observable<boolean>;
  error$!: Observable<string | null>;
  scripts: any[] = [];
  private modalService = inject(NgbModal);
  selectedNode: any;
  addButtonText: string = "Add New Test Suite/Test Script";
  removeButtonText: string = "Remove Test Suites/Test Scripts";
  iconSrcDelete: string =
    "../../../../../assets/images/virtusa-icons/remove-icon-dark.svg";
  isDisabled: boolean = true;
  selectedSuites: any[] = [];
  selectedScripts: any[] = [];
  fieldsList: any = [];
  isTestcaseMapping: boolean = false;
  selectedSuite: any;
  selectedSuiteForEdit: any;
  selectedScriptForEdit: any;
  isSuite: boolean = false;
  selectedFramework: string = "";
  user: any;
  isDuplicate: boolean = false;
  testSuitesList: any = [];

  private messageService = inject(MessageService);

  async ngOnInit(): Promise<void> {
    // this.user = await this.keycloakService.loadUserProfile();
    this.initializeTestData();
  }

  initializeTestData() {
    this.projectService.getAutomationProjectId().subscribe((id: any) => {
      this.automationProjectID = id;
    });

    this.projectService.getProjectId().subscribe((id) => {
      if (id != null) {
        this.projectID = id;
      }
    });
    this.selectCombinedTestSuiteComponent$ = this.store.select(
      selectCombinedTestSuiteComponent
    );

    this.projectService.getFrameworkType().subscribe((type: any) => {
      this.selectedFramework = type;
    });


    this.automatiCScriptService.getActiveNode().subscribe((item: any) => {
      this.selectedNode = item;

      if (this.selectedNode?.type === "test_script_group") {
        this.isSuite = true;
        this.selectedSuite = this.selectedNode;
      } else if (this.selectedNode?.type === "SCRIPT") {
        if (this.selectedNode?.parent?.type === "test_script_group") {
          this.isSuite = true;
          this.selectedSuite = this.selectedNode?.parent;
        } else if (this.selectedNode?.parent?.type === "SCRIPT") {
          let currentNode = this.selectedNode?.parent;
          while (currentNode && currentNode.level !== 2) {
            currentNode = currentNode.parent;
          }

          if (
            currentNode?.level === 2 &&
            currentNode?.type === "test_script_group"
          ) {
            this.isSuite = true;
            this.selectedSuite = currentNode;
          } else {
            this.isSuite = false;
          }
        }
      } else {
        this.isSuite = false;
      }
      // this.folders = (item.children ?? []).filter(
      //   (item: any) => item?.type === "test_script_group"
      // );

      this.folders = (item.children ?? [])
        .filter((item: any) => item?.type === "test_script_group")
        .map((item: any) => ({
          ...item,
          isSelectable: true,
          isEditable: true,
        }));
    });

    this.loading$ = this.store.select(selectLoading);
    this.error$ = this.store.select(selectAutomationError);

    this.loadNgRxData();
  }

  loadNgRxData() {
    this.selectCombinedTestSuiteComponent$.subscribe((item) => {
      this.testSuitesList = item?.testSuites;
      let filteredScripts: any = [];
      if (this.selectedNode?.type === "test_script_group") {
        this.isDuplicate = true;
        this.addButtonText = "Add New Test Script";
        this.removeButtonText = "Remove Test Scripts";
        filteredScripts = (item.testcases ?? []).filter(
          (item: any) =>
            item?.automationScriptGroup?.id === this.selectedNode?.id
        );
        this.paramTableData(filteredScripts);
      } else if (this.selectedNode?.type === "SCRIPT") {
        this.isDuplicate = false;
        this.addButtonText = "";
        this.removeButtonText = "";
        filteredScripts = (item.testcases ?? []).filter(
          (item: any) => item?.id === this.selectedNode?.id
        );
        this.paramTableData([...filteredScripts]);
      } else if (this.selectedNode?.type === "script_group") {
        this.addButtonText = "Add New Test Suite/Test Script";
        this.removeButtonText = "Remove Test Suites/Test Scripts";
        filteredScripts = item.testcases.filter(
          (item: any) => !item.automationScriptGroup
        );
      }

      this.paramTableData(filteredScripts);
    });

    this.scriptTestScript$ = this.store.select(selectTestScript);
    this.scriptTestScript$.subscribe((item) => {
      console.log("Test Script", item[item.length - 1]);
      if (this.isTestcaseMapping && item?.length) {
        this.openTestScriptMappingView(item[item.length - 1]);
        this.isTestcaseMapping = false;
      }
    });
  }

  paramTableData(item: any) {
    this.scripts = item;
    this.scripts = (this.scripts ?? []).map((item: any) => {
      const clonedItem = { ...item }; // Create a shallow copy of the item

      clonedItem.paramType = "-";
      clonedItem.paramName = "-";

      const children = (clonedItem.scriptParameters ?? [])
        .filter((param: any) => param.active)
        .map((param: any) => ({
          inputOutput: param.type === "INPUT" ? "Input" : "Output",
          paramName: param.name || "-",
          paramType: param.dataType || "-",
        }));

      return {
        ...clonedItem,
        ...(children.length > 0 ? { children } : {}),
        scriptParameters: undefined,
      };
    });

    console.log("TABLE--PARAM", this.scripts);
  }

  changeRemoveIcon(isActive: boolean) {
    this.iconSrcDelete = isActive
      ? "../../../../../assets/images/virtusa-icons/remove-icon-light.svg"
      : "../../../../../assets/images/virtusa-icons/remove-icon-dark.svg";
  }
  async handleTableActions(event: any) {
    switch (event?.type) {
      case "conditional-button":
        // Copy: pushing into the service list would leak the script row into the live breadcrumb.
        const breadcrumbData = [...this.breadcrumbService.list];
        let root = [
          {
            name: this.dataStore.data.name,
            key: "projectName",
          },
        ];
        if (
          !breadcrumbData.find(
            (ele: any) => ele.name === event?.data?.row?.name
          )
        ) {
          breadcrumbData.push({
            name: event?.data?.row?.name,
            key: event?.data?.row?.id,
          });
        }
        sessionStorage.setItem(
          "breadcrumb",
          JSON.stringify(root.concat(breadcrumbData))
        );

        this.restService.getEditorStatus(this.dataStore?.data?.id, this.automationProjectID, event?.data?.row?.id).subscribe({
          next: (response) => {
            if (response?.data?.canOpen) {
              this.setEditorOpenedStatus(this.dataStore?.data?.id, this.automationProjectID, event?.data?.row?.id);
              const newUrl = this.buildAppUrl(
                `project/${this.dataStore?.data?.id}/automation/${this.automationProjectID}/script/${event?.data?.row?.id}/editor-view`
              );
              window.open(newUrl, "_blank");
            } else {
              this.toaster.pop({ type: 'warning', text: response?.data?.message });
              this.setEditorOpenedStatus(this.dataStore?.data?.id, this.automationProjectID, event?.data?.row?.id);
            }
          },
          error: (error) => {
            console.error("Error checking editor status:", error);
          }
        });
        break;

      case "link":
        this.openModal(event?.data?.row);
        break;

      case "conditional-svg":
        this.selectedScriptForEdit = event?.data?.row;
        let params = {
          title: "Update Test Script",
          isEdit: true,
        };
        this.openGenericModal(true, event?.data?.row, params);
        break;

      case "contextMenu-conditional":
        if (event?.value === 'edit') {
          this.selectedScriptForEdit = event?.data?.row;
          let params = {
            title: "Update Test Script",
            isEdit: true,
          };
          this.openGenericModal(true, event?.data?.row, params);
        } else {
          this.duplicateScript(event?.value, event?.data?.row);
        }
        break;

      default:
        break;
    }
  }

  setEditorOpenedStatus(projectId: string, automationProjectId: string, scriptId: string) {
    this.restService.setEditorOpenStatus(projectId, automationProjectId, scriptId).subscribe({
      next: (response) => {
        console.log(response);
      },
      error: (error) => {
        console.error("Error setting editor status:", error);
      }
    });
  }

  openModal(data: any) {
    console.log(data.tcgTestCaseResultId);
    const modalRef = this.modalService.open(DataViewModalComponent, {
      centered: true,
      windowClass: "user-story-modal",
      size: "xl",
      backdrop: 'static',
    });
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.projectId = this.projectID;
    modalRef.componentInstance.contentList =
      testPrioritizationModalConfig.testCaseSourceCodeMapping;
    modalRef.componentInstance.title = "Test Case Details";
  }

  openGenericModal(
    isEdit: boolean,
    row: any,
    modalParams?: any,
    parentType?: any
  ) {
    const modalRef = this.openGenericModalDialog(modalParams);
    this.configureModalFields(modalRef, isEdit, row);

    modalRef.result.then((result: any) =>
      this.handleModalResult(isEdit, result, row, parentType)
    );
  }

  private openGenericModalDialog(modalParams: any): any {
    const modalRef = this.modalService.open(EditorItemModalComponent, {
      centered: true,
      windowClass: "add-item-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.configs = modalParams;
    return modalRef;
  }

  private configureModalFields(modalRef: any, isEdit: boolean, row: any): void {
    if (isEdit) {
      this.setupEditFields(row);
      const fields = this.mapFieldsWithValues(row);
      modalRef.componentInstance.fields = fields;
    } else {
      modalRef.componentInstance.fields = this.fieldsList;
    }
  }

  private setupEditFields(row: any): void {
    if (row?.type === "test_script_group") {
      this.fieldsList = [
        {
          id: "name",
          name: " Test Suite Name",
          dataType: "string",
          placeholder: " Test Suite Name",
        },
      ];
    } else {
      this.fieldsList = [
        {
          name: "Test Script Name",
          dataType: "string",
          id: "name",
          placeholder: "Test Script Name",
        },
      ];
    }
  }

  private mapFieldsWithValues(row: any): any[] {
    return this.fieldsList.map((field: any) => ({
      ...field,
      value: row[field.id] || "",
    }));
  }

  private handleModalResult(isEdit: boolean, result: any, row: any, parentType: any): void {
    if (isEdit) {
      this.handleEditResult(result, row, parentType);
    } else {
      this.handleCreateResult(result, parentType);
    }
  }

  private handleEditResult(result: any, row: any, parentType: any): void {
    if (parentType === "test_script_group") {
      this.updateTestSuite(result, row);
    } else {
      this.updateTestScript(result, row);
    }
  }

  private updateTestSuite(result: any, row: any): void {
    if (this.isNameExists(result?.value?.name, this.folders, this.selectedSuiteForEdit?.id)) {
      this.toaster.pop({ type: 'error', text: MessageEnum.TEST_SUITE_NAME_DUPLICATE });
      return;
    }

    this.store.dispatch(
      AutomationActions.updateScriptGroup({
        projectId: this.projectID,
        automationProjectId: this.automationProjectID,
        id: row?.id,
        changes: {
          name: result?.value?.name,
          type: "SCRIPT",
        },
      })
    );
  }

  private updateTestScript(result: any, row: any): void {
    if (this.isNameExists(result?.value?.name, this.scripts, this.selectedScriptForEdit?.id)) {
      this.toaster.pop({ type: 'error', text: MessageEnum.TEST_SCRIPT_NAME_DUPLICATE });
      return;
    }

    this.store.dispatch(
      AutomationActions.renameTestScript({
        projectId: this.projectID,
        automationProjectId: this.automationProjectID,
        id: row?.id,
        changes: {
          name: result?.value?.name,
          type: "SCRIPT",
          automationGroupId: row?.automationScriptGroup?.id,
          entityUsageList: [],
        },
      })
    );
  }

  private handleCreateResult(result: any, parentType: any): void {
    if (parentType === "test_script_create") {
      this.createTestScriptInSuite(result);
    } else {
      this.createTestSuiteOrScript(result);
    }
  }

  private createTestScriptInSuite(result: any): void {
    if (this.isNameExists(result?.value?.name, this.scripts)) {
      this.toaster.pop({ type: 'error', text: MessageEnum.TEST_SCRIPT_NAME_DUPLICATE });
      return;
    }

    if (!this.selectedFramework) {
      this.toaster.pop({ type: 'error', text: MessageEnum.FRAMEWORK_TYPE_SELECTION_REQUIRED });
      return;
    }

    this.isTestcaseMapping = true;
    this.store.dispatch(
      AutomationActions.addTestScript({
        projectId: this.projectID,
        automationProjectId: this.automationProjectID,
        testScript: {
          name: result?.value?.name,
          type: "SCRIPT",
          automationGroupId: this.selectedNode?.id,
        },
      })
    );
  }

  private createTestSuiteOrScript(result: any): void {
    const type = result?.fields.find((item: any) => item.key === "type");

    if (type?.value === "test_suite") {
      this.createTestSuite(result);
    } else {
      this.createStandaloneTestScript(result);
    }
  }

  private createTestSuite(result: any): void {
    if (this.isNameExists(result?.value?.test_suite_name, this.folders)) {
      this.toaster.pop({ type: 'error', text: MessageEnum.TEST_SCRIPT_NAME_DUPLICATE });
      return;
    }

    this.store.dispatch(
      AutomationActions.addScriptGroup({
        projectId: this.projectID,
        automationProjectId: this.automationProjectID,
        scriptGroup: {
          name: result?.value?.test_suite_name,
          type: "SCRIPT",
        },
      })
    );
  }

  private createStandaloneTestScript(result: any): void {
    const scriptName = result?.value?.test_script_name ?? result?.value?.name;

    if (this.isNameExists(scriptName, this.scripts)) {
      this.toaster.pop({ type: 'error', text: MessageEnum.TEST_SCRIPT_NAME_DUPLICATE });
      return;
    }

    if (!this.selectedFramework) {
      this.toaster.pop({ type: 'error', text: MessageEnum.FRAMEWORK_TYPE_SELECTION_REQUIRED });
      return;
    }

    this.isTestcaseMapping = true;
    this.store.dispatch(
      AutomationActions.addTestScript({
        projectId: this.projectID,
        automationProjectId: this.automationProjectID,
        testScript: {
          name: scriptName,
          type: "SCRIPT",
        },
      })
    );
  }

  isNameExists(name: string, dataList: any, excludeId?: string): boolean {
    const normalizedName = name?.toLowerCase()?.trim();
    return dataList
      ?.filter((script: any) => script?.id !== excludeId) // exclude current editing item
      ?.some(
        (script: any) => script?.name?.toLowerCase()?.trim() === normalizedName
      );
  }

  openTestScriptMappingView(item: any) {
    const modalRef = this.modalService.open(ScriptMappingComponent, {
      centered: true,
      windowClass: "scrip-mapping-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.displayStep = "Step 2/2";
    if (item) {
      modalRef.componentInstance.data = {
        ...item,
        projectId: this.projectID,
        automationId: this.automationProjectID,
        scriptId: item?.id,
      };
    }
    modalRef.result.then((result) => {
      console.log(result);
      this.isTestcaseMapping = false;
      this.refreshData();
    });
  }

  removeTestSuites() {
    let idList = this.getSelectedScriptIds();

    this.restService
      .deleteValidationReusableScript(this.projectID, this.automationProjectID, idList)
      .subscribe((response: any) => {
        let skippedList = response?.data || [];
        let deleteScriptIds = this.getDeletableScriptIds(skippedList);
        let deleteSuiteIds = this.getDeletableSuiteIds(skippedList);

        let result = { deleteScriptIds, deleteSuiteIds, skippedList };

        if (skippedList.length > 0) {
          if (this.selectedScripts.length > 0 && this.selectedSuites.length > 0) {
            this.removeMixedSelectionCaution(result);
          } else if (this.selectedScripts.length > 0) {
            this.removeTestScriptsCaution(result);
          } else {
            this.removeTestSuitesCaution(result);
          }
        } else {
          if (this.selectedScripts.length > 0 && this.selectedSuites.length > 0) {
            this.performMixedDelete(deleteScriptIds, deleteSuiteIds);
          } else {
            let ids = this.selectedSuites.map((suite: any) => suite.id);
            this.deleteConfirmation(ids);
          }
        }
      });
  }

  private getSelectedScriptIds(): any[] {
    let selectedSuiteScriptIds = this.selectedSuites.flatMap(
      (suite: any) => suite.children.map((child: any) => child.id)
    );
    const selectedScriptIds = this.selectedScripts.map((s: any) => s.id);
    return [...selectedScriptIds, ...selectedSuiteScriptIds];
  }

  private getDeletableScriptIds(skippedList: any[]): any[] {
    let skippedIds = new Set(skippedList.map((item: any) => item.id));
    return this.selectedScripts
      .filter((script: any) => !skippedIds.has(script.id))
      .map((script: any) => script.id);
  }

  private getDeletableSuiteIds(skippedList: any[]): any[] {
    let invalidScriptIds = skippedList.map((s: any) => s.id);
    return this.selectedSuites
      .filter((suite: any) => {
        let allScriptIds = suite.children.map((child: any) => child.id);
        return allScriptIds.every((id: any) => !invalidScriptIds.includes(id));
      })
      .map((suite: any) => suite.id);
  }

  performDelete(ids?: any[]): void {
    let idList = ids?.length ? ids : this.getSelectedScriptIds();

    if (this.selectedScripts.length > 0) {
      // Delete Test Scripts (bulk)
      this.store.dispatch(
        AutomationActions.deleteTestScripts({
          projectId: this.projectID,
          automationProjectId: this.automationProjectID,
          idList
        })
      );
    }
    if (this.selectedSuites.length > 0) {
      // Delete Test Suites (bulk)
      this.store.dispatch(
        AutomationActions.deleteScriptGroups({
          projectId: this.projectID,
          automationProjectId: this.automationProjectID,
          idList
        })
      );
    }
  }

  private performMixedDelete(scriptIds: any[], suiteIds: any[]): void {
    if (this.selectedScripts.length > 0) {
      // Delete Test Scripts (bulk)
      this.store.dispatch(
        AutomationActions.deleteTestScripts({
          projectId: this.projectID,
          automationProjectId: this.automationProjectID,
          idList: scriptIds,
        })
      );
    }
    if (this.selectedSuites.length > 0) {
      // Delete Test Suites (bulk)
      this.store.dispatch(
        AutomationActions.deleteScriptGroups({
          projectId: this.projectID,
          automationProjectId: this.automationProjectID,
          idList: suiteIds,
        })
      );
    }
  }

  deleteConfirmation(idList?: any): void {
    let modalRef = this.modalService.open(DeleteConfirmationComponent, {
      windowClass: "delete-confirmation-window",
      centered: true,
      size: "sm",
      backdrop: "static",
    });
    modalRef.componentInstance.data = {
      title: "Confirm Deletion",
      description:
        this.selectedScripts.length > 0
          ? "Are you sure you want to delete the selected Test Scripts?"
          : "Are you sure you want to delete the selected Test Suites?",
    };

    modalRef.result.then((confirmed) => {
      if (confirmed) {
        this.performDelete(idList);
      }
    });
  }

  removeTestScriptsCaution(data: any): void {
    let modalRef = this.modalService.open(DeleteCautionModalComponent, {
      centered: true,
      size: "lg",
      backdrop: "static",
    });

    modalRef.componentInstance.configs = {
      subTitle: "Unable to Delete All Selected Test Scripts",
      cautionMessage1:
        data.skippedList.length +
        " of the selected test scripts are currently used in test plans. To avoid breaking existing test plans, these test scripts cannot be deleted.",
      cautionMessage2:
        "Only test scripts that are not currently in use will be removed.",
      footerMessage1:
        "You can delete the remaining test scripts that are not used in any test plans.",
      footerMessage2:
        "To delete the listed test scripts, first remove their references from the test plans mentioned above.",
      tableData: data.skippedList,
      tableTitle: "Details of Scripts in Use",
      deleteButtonText: data.deleteScriptIds.length > 0 ? "Delete Unused Scripts Only" : '',
      columns: testScriptDeleteTableColumns,
      projectId: this.projectID,
      automationProjectId: this.automationProjectID,
    };

    modalRef.result.then((confirmed) => {
      if (confirmed && data.deleteScriptIds.length > 0) {
        // Delete Test Scripts (bulk)
        this.performDelete(data.deleteScriptIds);
      }
    });
  }

  removeTestSuitesCaution(data: any): void {
    let modalRef = this.modalService.open(DeleteCautionModalComponent, {
      centered: true,
      size: "lg",
      backdrop: "static",
    });

    modalRef.componentInstance.configs = {
      subTitle: "Unable to Delete All Selected Test Suites",
      cautionMessage1:
        data.skippedList.length +
        " of the test scripts within the selected suites are currently used in test plans. To avoid breaking existing test plans, these test suites cannot be deleted.",
      cautionMessage2:
        "Only test suites where none of the scripts are in use will be removed.",
      footerMessage1:
        "You can delete the remaining test suites that that do not include any in use test scripts.",
      footerMessage2:
        "To delete the listed test suites, first remove their referenced test scripts from the test plans mentioned above.",
      tableData: data.skippedList,
      tableTitle: "Details of Scripts in Use",
      deleteButtonText: data.deleteSuiteIds.length > 0 ? "Delete Unused Test Suites Only" : '',
      columns: testSuiteDeleteTableColumns,
      projectId: this.projectID,
      automationProjectId: this.automationProjectID,
    };

    modalRef.result.then((confirmed) => {
      if (confirmed && data.deleteSuiteIds.length > 0) {
        // Delete Test Scripts (bulk)
        this.performDelete(data.deleteSuiteIds);
      }
    });
  }

  private removeMixedSelectionCaution(data: any): void {
    let modalRef = this.modalService.open(DeleteCautionModalComponent, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
    });

    modalRef.componentInstance.configs = {
      subTitle: "Unable to Delete All Selected Components",
      cautionMessage1:
        data.skippedList.length +
        " of the selected test scripts are currently used in test plans. To avoid breaking existing test plans, these test scripts cannot be deleted.",
      cautionMessage2:
        "Only test scripts that are not currently in use and test suites where none of their scripts are in use will be deleted.",
      footerMessage1:
        "You can delete the remaining test scripts and test suites that are not used in any test plans.",
      footerMessage2:
        "To delete the listed components, remove their references from the test plans mentioned above.",
      tableData: data.skippedList,
      tableTitle: "Details of Scripts in Use",
      deleteButtonText: data.deleteScriptIds.length > 0 || data.deleteSuiteIds.length > 0 ? "Delete Unused Components Only" : '',
      columns: testSuiteDeleteTableColumns,
      projectId: this.projectID,
      automationProjectId: this.automationProjectID,
    };

    modalRef.result.then((confirmed) => {
      if (confirmed && (data.deleteScriptIds.length > 0 || data.deleteSuiteIds.length > 0)) {
        this.performMixedDelete(data.deleteScriptIds, data.deleteSuiteIds);
      }
    });
  }

  addNewTestSuite() {
    if (
      this.selectedNode?.type === "test_script_group" ||
      this.selectedNode?.type === "SCRIPT"
    ) {
      this.fieldsList = [
        {
          name: "Test Script Name",
          dataType: "string",
          id: "name",
          placeholder: "Test Script Name",
        },
      ];
      this.openGenericModal(
        false,
        {},
        {
          title: "Add New Test Script",
          saveBtnText: "Add",
        },
        "test_script_create"
      );
    } else if (this.selectedNode?.type === "script_group") {
      this.fieldsList = [
        {
          id: "type",
          key: "type",
          name: "Type",
          dataType: "radio",
          options: [
            { value: "test_suite", label: " Test Suite" },
            { value: "test_script", label: "Test Script" },
          ],
          customClass: "col-md-6",
          value: "test_suite",
        },
        {
          id: "test_suite_name",
          key: "test_suite_name",
          name: " Test Suite Name",
          dataType: "string",
          placeholder: " Test Suite Name",
          customClass: "mt-3",
          visibleIf: { key: "type", value: "test_suite" },
        },
        {
          id: "test_script_name",
          key: "test_script_name",
          name: "Test Script Name",
          dataType: "string",
          placeholder: "Test Script Name",
          customClass: "mt-3",
          visibleIf: { key: "type", value: "test_script" },
        },
      ];
      this.openGenericModal(
        false,
        {},
        {
          title: "Add New Test Suite/Test Script",
          saveBtnText: "Add",
          step: " Step 1/2",
        }
      );
    }
  }

  handleSelectedCards(selectedCards: any[]) {
    this.selectedSuites = selectedCards;
    console.log("Selected Cards:", this.selectedSuites);
    this.checkRemoveButtonStatus();
  }

  checkRemoveButtonStatus() {
    if (this.selectedScripts.length > 0 || this.selectedSuites.length > 0) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  handleRowSelect(event: any) {
    this.selectedScripts = event?.data;
    this.checkRemoveButtonStatus();
  }

  onEditSuite(event: any) {
    this.selectedSuiteForEdit = event.$event;
    this.openGenericModal(
      true,
      event?.$event,
      {
        title: "Update Test Suite",
        isEdit: true,
      },
      "test_script_group"
    );
  }

  refreshData() {
    this.store.dispatch(
      AutomationActions.loadScriptGroup({
        projectId: this.projectID,
        automationProjectId: this.automationProjectID,
      })
    );
  }

  duplicateScript(type: string, script: any) {
    console.log("duplicate script->", this.selectedScripts);

    const modalRef = this.modalService.open(ScriptDuplicateModalComponent, {
      centered: true,
      size: "m"
    });

    modalRef.componentInstance.configs = {
      title: type === 'duplicate' ? 'Duplicate Script' : "Copy & Move Script",
      type: type,
      suites: this.testSuitesList,
      suiteName: script?.automationScriptGroup?.name || "",
      saveBtn: type === 'duplicate' ? "Duplicate" : "Copy & move",
      script: script,
      projectId: this.projectID,
      automationProjectId: this.automationProjectID,
    }

    modalRef.result.then((result: any) => {
      if (result) { }
    });

  }
}
